import { CategoryIcon } from '@modules/common/components/CategoryIcon';
import { Category } from '@modules/common/types';
import { Box, Stack, Typography } from '@mui/material';

const CATEGORY_INFO = [
  {
    category: Category.Help,
    description: 'Request for assistance, guidance or support from users',
  },
  {
    category: Category.Improvement,
    description: 'Suggestions and feature requests from users',
  },
  {
    category: Category.Praise,
    description: 'Appreciation from users',
  },
  {
    category: Category.Complaint,
    description: 'Problems faced by users',
  },
];

export const CategoryInfoTooltipContent = () => {
  return (
    <Stack p="12px" minWidth={450}>
      <Typography variant="subtitle2" color="text.primary">
        All predictions fall under one of the following categories:
      </Typography>
      <Stack mt={2}>
        {CATEGORY_INFO.map(({ category, description }) => (
          <Box key={category} mb={1} pl={1}>
            <Box sx={{ mr: '8px', display: 'inline' }}>
              <CategoryIcon category={category} />
            </Box>
            <Typography variant="caption" color="text.primary">
              {category}:{' '}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {description}
            </Typography>
          </Box>
        ))}
      </Stack>
    </Stack>
  );
};
